// LM(anahtar, yedek): cevrilen metni window.LM_T'den okur, yoksa yedege duser.
function LM(a, yedek) {
  var t = (typeof window !== 'undefined' && window.LM_T) || {};
  return t[a] || yedek;
}
/**
 * Teslimat cizgisi: siparis -> kargo -> teslim tarihlerini magaza saat diliminde
 * (Europe/Istanbul) is gunu ve resmi tatil atlayarak hesaplar.
 *
 * Neden istemci tarafinda: sayfa onbellege alinsa bile tarih her ziyarette
 * yeniden hesaplanir; sunucu tarafinda uretilen tarih bir gun sonra bayat olur.
 */

const AYLAR = LM('aylar', 'Oca,Şub,Mar,Nis,May,Haz,Tem,Ağu,Eyl,Eki,Kas,Ara').split(',');
const GUNLER = LM('gunler', 'Pazar,Pazartesi,Salı,Çarşamba,Perşembe,Cuma,Cumartesi').split(',');

/** Magaza saat diliminde "simdi"yi {yil, ay, gun, saat, dakika} olarak verir. */
function magazaSimdi(dilim) {
  const p = new Intl.DateTimeFormat('en-CA', {
    timeZone: dilim,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hour12: false,
  }).formatToParts(new Date());
  const al = (t) => Number(p.find((x) => x.type === t).value);
  return { yil: al('year'), ay: al('month'), gun: al('day'), saat: al('hour') % 24, dakika: al('minute') };
}

const anahtar = (d) => `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`;

class TeslimatCizgisi extends HTMLElement {
  connectedCallback() {
    this.dilim = this.dataset.dilim || 'Europe/Istanbul';
    this.kesim = (this.dataset.kesim || '14:00').split(':').map(Number);
    this.hazirlikMin = Number(this.dataset.hazirlikMin || 1);
    this.hazirlikMax = Number(this.dataset.hazirlikMax || 3);
    this.yolMin = Number(this.dataset.yolMin || 1);
    this.yolMax = Number(this.dataset.yolMax || 3);
    this.cumartesi = this.dataset.cumartesi === 'true';
    this.tatiller = new Set((this.dataset.tatiller || '').split(',').map((s) => s.trim()).filter(Boolean));
    this.hesapla();
    // Gun/kesim saati degisimini yakala: dakikada bir yeterli, geri sayim da bundan beslenir.
    this.zamanlayici = setInterval(() => this.hesapla(), 60000);
  }

  disconnectedCallback() {
    clearInterval(this.zamanlayici);
  }

  isGunuMu(d) {
    const h = d.getUTCDay();
    if (h === 0) return false;
    if (h === 6 && !this.cumartesi) return false;
    return !this.tatiller.has(anahtar(d));
  }

  sonrakiIsGunu(d) {
    const y = new Date(d.getTime());
    do { y.setUTCDate(y.getUTCDate() + 1); } while (!this.isGunuMu(y));
    return y;
  }

  isGunuEkle(d, n) {
    let y = new Date(d.getTime());
    if (!this.isGunuMu(y)) y = this.sonrakiIsGunu(y);
    for (let i = 0; i < n; i += 1) y = this.sonrakiIsGunu(y);
    return y;
  }

  hesapla() {
    const s = magazaSimdi(this.dilim);
    const bugun = new Date(Date.UTC(s.yil, s.ay - 1, s.gun));
    const kesimDakika = this.kesim[0] * 60 + (this.kesim[1] || 0);
    const simdiDakika = s.saat * 60 + s.dakika;
    const kesimGecti = simdiDakika >= kesimDakika;

    // Baslangic gunu: bugun is gunu ve kesim gecmediyse bugun, yoksa sonraki is gunu.
    let baslangic = bugun;
    if (kesimGecti || !this.isGunuMu(bugun)) baslangic = this.sonrakiIsGunu(bugun);

    const kargoIlk = this.isGunuEkle(baslangic, Math.max(0, this.hazirlikMin - 1));
    const kargoSon = this.isGunuEkle(baslangic, Math.max(0, this.hazirlikMax - 1));
    const teslimIlk = this.isGunuEkle(kargoIlk, this.yolMin);
    const teslimSon = this.isGunuEkle(kargoSon, this.yolMax);

    this.yaz('siparis', this.tarih(bugun));
    this.yaz('kargo', this.aralik(kargoIlk, kargoSon));
    this.yaz('teslim', this.aralik(teslimIlk, teslimSon));

    const ustAlan = this.querySelector('[data-ref="ust"]');
    if (ustAlan) {
      const ayniGun = anahtar(kargoIlk) === anahtar(bugun);
      let metin;
      if (!kesimGecti && this.isGunuMu(bugun)) {
        const kalan = kesimDakika - simdiDakika;
        const saat = Math.floor(kalan / 60);
        const dakika = kalan % 60;
        const sure = saat > 0 ? `${saat} saat ${dakika} dakika` : `${dakika} dakika`;
        const sablon = ayniGun ? this.dataset.metinBugun : this.dataset.metinYarin;
        metin = (sablon || '').replace('[sure]', sure).replace('[gun]', this.tarih(kargoIlk));
      } else {
        metin = (this.dataset.metinGecti || '').replace('[gun]', `${GUNLER[kargoIlk.getUTCDay()]} ${this.tarih(kargoIlk)}`);
      }
      ustAlan.innerHTML = metin;
    }
    this.hidden = false;
  }

  tarih(d) {
    return `${d.getUTCDate()} ${AYLAR[d.getUTCMonth()]}`;
  }

  aralik(a, b) {
    if (anahtar(a) === anahtar(b)) return this.tarih(a);
    // Ayni ay ise ayi bir kez yaz: dar ekranda "20 – 26 Agu" tek satirda kaliyor.
    if (a.getUTCMonth() === b.getUTCMonth()) return `${a.getUTCDate()} – ${this.tarih(b)}`;
    return `${this.tarih(a)} – ${this.tarih(b)}`;
  }

  yaz(ad, deger) {
    const e = this.querySelector(`[data-tarih="${ad}"]`);
    if (e) e.textContent = deger;
  }
}

if (!customElements.get('teslimat-cizgisi')) {
  customElements.define('teslimat-cizgisi', TeslimatCizgisi);
}

/**
 * Ayni sayidan (hazirlik/yol suresi, kargo ucreti) Google'in bekledigi
 * shippingDetails + iade politikasi alanlarini mevcut Product JSON-LD'sine ekler.
 * Neden JS ile: Shopify'in `structured_data` filtresi duzenlenemiyor; ikinci bir
 * Product dugumu eklemek yerine var olan dugum zenginlestiriliyor.
 */
function yapisalVeriZenginlestir(kutu) {
  const betikler = [...document.querySelectorAll('script[type="application/ld+json"]')];
  for (const betik of betikler) {
    let veri;
    try { veri = JSON.parse(betik.textContent); } catch { continue; }
    if (veri['@type'] !== 'Product' || !veri.offers) continue;
    const teklifler = Array.isArray(veri.offers) ? veri.offers : [veri.offers];
    for (const teklif of teklifler) {
      teklif.shippingDetails = {
        '@type': 'OfferShippingDetails',
        shippingRate: {
          '@type': 'MonetaryAmount',
          value: Number(kutu.dataset.kargoUcret || 0),
          currency: kutu.dataset.parabirimi || 'TRY',
        },
        shippingDestination: { '@type': 'DefinedRegion', addressCountry: kutu.dataset.ulke || 'TR' },
        deliveryTime: {
          '@type': 'ShippingDeliveryTime',
          handlingTime: {
            '@type': 'QuantitativeValue',
            minValue: Number(kutu.dataset.hazirlikMin || 1),
            maxValue: Number(kutu.dataset.hazirlikMax || 3),
            unitCode: 'DAY',
          },
          transitTime: {
            '@type': 'QuantitativeValue',
            minValue: Number(kutu.dataset.yolMin || 1),
            maxValue: Number(kutu.dataset.yolMax || 3),
            unitCode: 'DAY',
          },
        },
      };
      if (kutu.dataset.iadeGun) {
        teklif.hasMerchantReturnPolicy = {
          '@type': 'MerchantReturnPolicy',
          applicableCountry: kutu.dataset.ulke || 'TR',
          returnPolicyCategory: 'https://schema.org/MerchantReturnFiniteReturnWindow',
          merchantReturnDays: Number(kutu.dataset.iadeGun),
          returnMethod: 'https://schema.org/ReturnByMail',
          returnFees: 'https://schema.org/FreeReturn',
        };
      }
    }
    // Google'in urun zengin sonuclarinda bekledigi ek alanlar
    for (const teklif of teklifler) {
      teklif.itemCondition = 'https://schema.org/NewCondition';
      teklif.seller = { '@type': 'Organization', name: 'LaMua Home' };
      if (!teklif.priceValidUntil) {
        const y = new Date();
        y.setFullYear(y.getFullYear() + 1);
        teklif.priceValidUntil = y.toISOString().slice(0, 10);
      }
    }
    veri.itemCondition = 'https://schema.org/NewCondition';
    // Malzeme / olcu bilgisi urun aciklamasindaki listeden okunur
    const ozellikler = {};
    document.querySelectorAll('.product-details li, .rte li').forEach((satir) => {
      const p = satir.textContent.split(':');
      if (p.length >= 2) ozellikler[p[0].trim().toLocaleLowerCase('tr')] = p.slice(1).join(':').trim();
    });
    if (ozellikler['malzeme'] && !veri.material) veri.material = ozellikler['malzeme'];
    if (ozellikler['ölçü'] && !veri.size) veri.size = ozellikler['ölçü'];
    if (ozellikler['desen'] && !veri.pattern) veri.pattern = ozellikler['desen'];
    // Metafield/barkod DOM ayristirmasindan ONCE gelir: aciklama bicimi degisince
    // yapisal veri sessizce bosalmasin. gtin13 tam 13 hane olmali, degilse yazma.
    if (kutu.dataset.malzeme) veri.material = kutu.dataset.malzeme;
    if (kutu.dataset.olcu) veri.size = kutu.dataset.olcu;
    // gtin13 BILEREK yazilmiyor: magazanin 122 barkodunun tamami "2" onekli, yani
    // GS1 kisitli dagitim (magaza ici) araligi. Google Merchant Center dokumani
    // (okundu 01.09.2026): "Don't submit a GTIN in the restricted ranges.
    // Restricted ranges have the following prefixes: 02, 04, or 2." Kontrol hanesi
    // dogru olmasi gecerli GTIN yapmaz. Gercek GS1 barkodu alinirsa bu satir acilir.
    betik.textContent = JSON.stringify(veri);
    return;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const kutu = document.querySelector('teslimat-cizgisi[data-yapisal-veri="true"]');
  if (kutu) yapisalVeriZenginlestir(kutu);
});
